import React from "react";

export function SearchForm({
  setInput,
  handleSearch,
  input,
  isLoading
}) {
 
  const handleInput = (e) => {
    const inputValue = e.target.value;
    setInput(inputValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex items-center gap-3 w-[75%] rounded-3xl mx-auto md:rounded-3xl md:border md:border-green-900 md:bg-white justify-center search-bar-shadow mb-6 p-2">
        <input
          type="text"
          value={input}
          placeholder="Enter instagram @username"
          className="flex-1 "
          onChange={handleInput}
        />
        <button
          type="submit"
          disabled={isLoading || !input.trim()}
          className="cursor-pointer bg-gradient-to-t from-green-600 to-green-900 text-white w-20 h-12 rounded-3xl flex items-center justify-center text-lg font-semibold disabled:opacity-70"
        >
          {isLoading ? (
            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : (
            "Check"
          )}
        </button>
      </div>
    </form>
  );
}